import { render } from "./ReportarPagoGas.vue?vue&type=template&id=2f9868b8&scoped=true"
import script from "./ReportarPagoGas.vue?vue&type=script&lang=js"
export * from "./ReportarPagoGas.vue?vue&type=script&lang=js"

import "./ReportarPagoGas.vue?vue&type=style&index=0&id=2f9868b8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9868b8"]])

export default __exports__